/* eslint-disable @typescript-eslint/no-explicit-any */

const APPLICATION_VERSION = 1_16_25;
const { APPLICATION_SERVER, COMPANY_NAME } = (window as any).globalConfig;

export { APPLICATION_SERVER, COMPANY_NAME, APPLICATION_VERSION };
